export enum IdStructure {
  SUBPATH = 'subpath',
  DELIMITER = 'delimiter',
}
